module.exports = __webpack_public_path__ + "static/media/ferry-lose.23f66c10.png";